import {Injectable} from '@angular/core';
import { EntityState, EntityStore, persistState, StoreConfig } from '@datorama/akita';
import { LabVisitMetadata } from './lab.model';
import * as localForage from 'localforage';

const labsStore = localForage.createInstance({
  name: 'patientLynk',
  storeName: 'labs_store'
});
persistState({ include: ['labs'], storage: labsStore });

export interface LabsState extends EntityState<LabVisitMetadata> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'labs', idKey: 'lab_record_id' })
export class LabsStore extends EntityStore<LabsState> {

  constructor() {
    super();
  }

}
